import { ArrowLeft } from '@phosphor-icons/react';

const PageHeader = ({
	title,
	subtitle,
	icon,
	actions,
	actionButton,
	onBack,
	className = '',
	contentClassName = '',
	titleClassName = '',
	subtitleClassName = '',
	leftContent,
}) => {
	const resolvedActions = actions || (
		actionButton?.show !== false && actionButton?.label ? (
			<button
				type={actionButton.type || 'button'}
				onClick={actionButton.onClick}
				disabled={actionButton.disabled}
				className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors ${
					actionButton.disabled
						? 'cursor-not-allowed bg-surface-2 text-content-muted'
						: 'bg-amber text-on-amber hover:bg-amber-hover'
				} ${actionButton.className || ''}`.trim()}
				aria-label={actionButton.ariaLabel || actionButton.label}
			>
				{actionButton.icon}
				{actionButton.label}
			</button>
		) : null
	);

	return (
		<div className={`mb-4 ${className}`.trim()}>
			<div className="min-w-0 flex flex-col gap-4 md:flex-row md:flex-wrap md:items-center md:justify-between">
				<div className={`min-w-0 mb-0 md:mb-6 md:flex-1 md:basis-64 ${contentClassName}`.trim()}>
					<div className="flex items-start gap-3">
						{onBack && (
							<button
								type="button"
								onClick={onBack}
								className="shrink-0 rounded-lg border border-line bg-surface-2 p-2 text-content shadow-lg transition-colors hover:bg-line"
								aria-label="Volver"
							>
								<ArrowLeft size={20} />
							</button>
						)}
						{leftContent || (title && (
							<h1 className={`min-w-0 flex-1 flex items-start gap-2 ${onBack ? 'pl-0' : 'pl-12'} pt-0.5 text-2xl font-bold text-content md:pl-0 md:pt-0 ${titleClassName}`.trim()}>
								{icon && <span className="inline-flex h-8 shrink-0 items-center">{icon}</span>}
								<span className="min-w-0 break-words">{title}</span>
							</h1>
						))}
					</div>
					{!leftContent && subtitle && (
						<p className={`mt-2 text-content ${subtitleClassName}`.trim()}>
							{subtitle}
						</p>
					)}
				</div>
				{resolvedActions && <div className="flex max-w-full flex-wrap items-center gap-2 md:shrink-0">{resolvedActions}</div>}
			</div>
		</div>
	);
};

export default PageHeader;
